import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, Button, Alert } from "react-bootstrap";

import "./ExportPackagesModal.scss";
import { DropdownList } from "react-widgets";
import {
  exportPackages,
  getLogisticsWarnings,
} from "../../../../../Backend/LogisticsRequests";
import SchoolSelection from "../../../../../Components/SchoolSelection/SchoolSelection";

export function ExportPackagesModal({ exportOnClick, cancelOnClick, ...props }) {
  const [t] = useTranslation();
  const exportOptions = [
    { id: false, name: t("Not exported") },
    { id: true, name: t("Exported") },
  ];

  //   const [schoolOption, setSchoolOption] = useState();
  const [exportButtonDisabled, setExportButtonDisabled] = useState(true);

  const [schoolSelected, setSchoolSelected] = useState();
  const [schoolSelection, setSchoolSelection] = useState();

  const [havePendingLines, setHavePendingLines] = useState(false);
  const [haveLinesToBeExported, setHaveLinesToBeExported] = useState(false);

  const [loading, setLoading] = useState(false);
  const [exportOnlyNews, setExportOnlyNews] = useState(false);

  //#region Hooks
  useEffect(
    function enableExportButton() {
      if (schoolSelected) {
        setExportButtonDisabled(false);
        getLogisticsWarns();
      } else {
        setExportButtonDisabled(true);
      }
    },
    [schoolSelected]
  );

  //   useEffect(function showAlert() {
  //     getLogisticsWarns();
  //   }, []);

  //#endregion

  //#region Handlers
  function handleCancelOnClick() {
    cancelOnClick()
    // props.onHide();
  }

  async function handleExportOnClick() {
    setLoading(true);
    await postExport();
    setLoading(false);
    exportOnClick();
    // props.onHide();
  }

  //#endregion

  //#region Functions
  async function postExport() {
    const resp = await exportPackages(schoolSelected.schoolNumber, exportOnlyNews);
    return resp;
  }

  async function getLogisticsWarns() {
    const resp = await getLogisticsWarnings(schoolSelected.schoolNumber);
    if (resp.success) {
      setHavePendingLines(resp.data.havePendingLines);
      setHaveLinesToBeExported(resp.data.haveLinesToBeExported);
    }
    return resp;
  }

  //#endregion

  return (
    <Modal {...props} centered dialogClassName="export-modal">
      {loading ? (
        <div className="loader-container">
          <div className="loader" />
        </div>
      ) : (
        <>
          <Modal.Header className="export-modal-header" closeButton>
            <div className="title">Export packages</div>
          </Modal.Header>
          <Modal.Body className="export-modal-content">
            <div className="export-modal-content-elements">
              <Alert
                className="export-modal-content-alert"
                variant="warning"
                hidden={!havePendingLines}
              >
                <Alert.Heading>{t("ExportReceipWarningTitle1")}</Alert.Heading>
                <p>{t("ExportReceipWarningText1")}</p>
              </Alert>
              <Alert
                className="export-modal-content-alert"
                variant="warning"
                hidden={!haveLinesToBeExported}
              >
                <Alert.Heading>{t("ExportReceipWarningTitle2")}</Alert.Heading>
                <p>{t("ExportReceipWarningText2")}</p>
              </Alert>
              <SchoolSelection
                schoolSelected={schoolSelected}
                schoolSelection={schoolSelection}
                onClickChange={() => {
                  if (schoolSelection) {
                    setSchoolSelection(false);
                  } else {
                    setSchoolSelection(true);
                  }
                }}
                setSchoolSelection={setSchoolSelection}
                setSchoolSelected={setSchoolSelected}
              />
              <div
                className="export-check-wrapper"
                onClick={() => setExportOnlyNews(!exportOnlyNews)}
              >
                <div className="checkbox">
                  {exportOnlyNews ? "check_box" : "check_box_outline_blank"}
                </div>
                <div className="label">{t("ExportOnlyNewPackages")}</div>
              </div>
            </div>
            <div className="button-wrapper">
              <Button className="button-cancel" onClick={handleCancelOnClick}>
                {t("Close")}
              </Button>
              <Button
                className="button-export"
                onClick={handleExportOnClick}
                disabled={exportButtonDisabled}
              >
                {t("Export")}
              </Button>
            </div>
          </Modal.Body>
        </>
      )}
    </Modal>
  );
}
